module.exports = __webpack_public_path__ + "static/img/1050_big.c3def65.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1050_big.png
// module id = Dsd0
// module chunks = 1